export default {
  "PopoverContainer": "_PopoverContainer_idgvc_6",
  "Popover": "_Popover_idgvc_6",
  "PopoverAnchor": "_PopoverAnchor_idgvc_87"
};import "ni:sha-256;mgiaqyScW-LwT8mzriM8VZ2fOK8CFgl6n2ZDKpktlT4";